import { memo } from "react";
import {
  ERROR_DRIVERLESS_ROUTES_TITLE,
  WARNING_DRIVERLESS_ROUTES_TITLE,
} from "../../../consts/strings";
import { Modal } from "../Modal";
import { DriverlessRoutesActions } from "./DriverlessRoutesActions";
import { DriverlessRoutesContent } from "./DriverlessRoutesContent";

export const DriverlessRoutesModal = memo(
  ({ open, error, onClose, onContinue, driverlessRoutes }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        title={
          error
            ? ERROR_DRIVERLESS_ROUTES_TITLE
            : WARNING_DRIVERLESS_ROUTES_TITLE
        }
        content={
          <DriverlessRoutesContent
            driverlessRoutes={driverlessRoutes}
            error={error}
          />
        }
        actions={
          <DriverlessRoutesActions
            onCancel={onClose}
            onContinue={onContinue}
            error={error}
          />
        }
        maxWidth={"sm"}
      />
    );
  }
);
